import React from 'react';
import { Grid } from '@material-ui/core';
import Draggable from 'react-draggable';
import Chat from '../../../../components/chat/chat';

const Chatbox = ({
    showChatbox,
    draggable,
    hideTabs,
    caseId,
    patientId,
    handleNewChatRoom,
    handleSmallChatRoom,
    chatRomWidth,
    dragableChatRoom,
    exitFullScreen,
    handleFullScreen,
    dragPosition,
    currentTreatmentPlan,
    threeDimensionLink,
    handleVerticalSplit,
    hideSimulation,
    currentUserRole,
    socketRef,
    chatRoomMessages,
    privateChatMessages,
    intlChatMessages,
    loadingMessages,
}) => {
    return (
        <>
            {['DR'].includes(currentUserRole) ? (
                <>
                    {showChatbox && (
                        <>
                            <Chat
                                caseId={caseId}
                                patientId={patientId}
                                handleSmallChatRoom={handleSmallChatRoom}
                                handleNewChatRoom={handleNewChatRoom}
                                chatRomWidth={chatRomWidth}
                                hideTabs={hideTabs}
                                dragableChatRoom={dragableChatRoom}
                                exitFullScreen={exitFullScreen}
                                handleFullScreen={handleFullScreen}
                                handleVerticalSplit={handleVerticalSplit}
                                currentTreatmentPlan={currentTreatmentPlan}
                                threeDimensionLink={threeDimensionLink}
                                socketRef={socketRef}
                                chatRoomMessages={chatRoomMessages}
                                privateChatMessages={privateChatMessages}
                                intlChatMessages={intlChatMessages}
                                loadingMessages={loadingMessages}
                            />
                        </>
                    )
                    }
                </>
            ) : (
                <Grid
                    item
                    xs={12}
                    style={{ overflowX: 'auto' }}
                >
                    <Grid
                        container
                        className={
                            hideTabs && ['ADMIN', 'SADMIN'].includes(currentUserRole) && !showChatbox
                                ? 'chatRoom'
                                : hideTabs && ['DISTR'].includes(currentUserRole)
                                    ? 'chatRoomDISTR'
                                    : ''
                        }
                        style={{
                            gap: 4,
                            flexWrap: 'nowrap',
                            minWidth: hideTabs ? '1200px' : '100%', // Set fixed width when sub-chats are open (3-box layout)
                        }}
                    >
                        {hideTabs && (
                            <Chat
                                caseId={caseId}
                                patientId={patientId}
                                handleSmallChatRoom={handleSmallChatRoom}
                                handleNewChatRoom={handleNewChatRoom}
                                chatRomWidth={chatRomWidth}
                                hideTabs={hideTabs}
                                handleVerticalSplit={handleVerticalSplit}
                                hideSimulation={hideSimulation}
                                currentTreatmentPlan={currentTreatmentPlan}
                                threeDimensionLink={threeDimensionLink}
                                socketRef={socketRef}
                                chatRoomMessages={chatRoomMessages}
                                privateChatMessages={privateChatMessages}
                                intlChatMessages={intlChatMessages}
                                loadingMessages={loadingMessages}
                            />
                        )}
                        <Chat
                            caseId={caseId}
                            patientId={patientId}
                            handleSmallChatRoom={handleSmallChatRoom}
                            handleNewChatRoom={handleNewChatRoom}
                            chatRomWidth={chatRomWidth}
                            hideTabs={hideTabs}
                            dragableChatRoom={dragableChatRoom}
                            exitFullScreen={exitFullScreen}
                            handleFullScreen={handleFullScreen}
                            handleVerticalSplit={handleVerticalSplit}
                            hideSimulation={hideSimulation}
                            chatType={3}
                            currentTreatmentPlan={currentTreatmentPlan}
                            threeDimensionLink={threeDimensionLink}
                            socketRef={socketRef}
                            chatRoomMessages={chatRoomMessages}
                            privateChatMessages={privateChatMessages}
                            intlChatMessages={intlChatMessages}
                            loadingMessages={loadingMessages}
                        />
                        {/* Third ChatRoom */}
                        {hideTabs && ['ADMIN', 'SADMIN'].includes(currentUserRole) && (
                            <Chat
                                caseId={caseId}
                                patientId={patientId}
                                handleSmallChatRoom={handleSmallChatRoom}
                                handleNewChatRoom={handleNewChatRoom}
                                chatRomWidth={chatRomWidth}
                                hideTabs={hideTabs}
                                handleVerticalSplit={handleVerticalSplit}
                                hideSimulation={hideSimulation}
                                chatType={4}
                                currentTreatmentPlan={currentTreatmentPlan}
                                threeDimensionLink={threeDimensionLink}
                                socketRef={socketRef}
                                chatRoomMessages={chatRoomMessages}
                                privateChatMessages={privateChatMessages}
                                intlChatMessages={intlChatMessages}
                                loadingMessages={loadingMessages}
                            />
                        )}
                    </Grid>
                </Grid>
            )}
        </>
    );
};

export default Chatbox;
